export default __webpack_public_path__ + "static/media/activateReservedContract.3127c06d.svg";